import type { AxiosRequestConfig } from 'axios';
import { CacheTypeEnum, TOKEN_KEY } from '@mts/enums/cacheEnum';
import projectSetting from '@mts/settings/projectSetting';
import { deviceInfo, SERVICE_PREFIX } from '@mts/utils';
import { BasicKeys, Persistent } from '@mts/utils/cache/persistent';
import { getGlobalStore, getLocaleStore, getUserStore } from '@/store';
import { globSetting } from '../env';

const isLocal = projectSetting.permissionCacheType === CacheTypeEnum.LOCAL;

const LOWCODE_PATHS = [SERVICE_PREFIX.LCA, SERVICE_PREFIX.LCC];
const { device, platform, apiUrl } = globSetting;
const isSubPlatformByUrl = (url?: string) =>
  url && platform === 'LOWCODE' && !LOWCODE_PATHS.some((path) => url?.startsWith(apiUrl + path));

export function getRequestHeaders(config?: AxiosRequestConfig) {
  // console.log('getRequestHeaders', config.url, config);
  const userStore = getUserStore();
  const isSubPlatform = isSubPlatformByUrl(config?.url);
  const { breadcrumb = [] } = window.$mts.route?.meta || {};
  const headers: Recordable = {
    ...userStore.getUserHeader,
    'metas-env-group': localStorage.getItem('METAS-ENV-GROUP') || '',
    'metas-device-id': deviceInfo.deviceId,
    'metas-tenant-id': config?.headers?.['metas-tenant-id'] || userStore.getCurrentTenant,
    'metas-lang': getLocaleStore().getLocale,
    'metas-menu': encodeURIComponent(breadcrumb.join('/')),
    'metas-client': device,
    Authorization: isSubPlatform ? userStore.getSubToken : userStore.getToken,
  };
  if (isSubPlatform) {
    headers['metas-user-id'] = '';
  }
  // 分身绑定：本机存在分身绑定时附加分身标识头，后端 StationAvatarFilter 将请求改写为
  // 目标站位当前主设备身份执行；bind/unbind 自身、/public/*、/auth/* 等路径由后端排除
  if (device === 'PAD' && getGlobalStore().getIsAvatarBound) {
    headers['X-Station-Avatar'] = '1';
  }
  return headers;
}
!localStorage.getItem('METAS-ENV-GROUP') && localStorage.setItem('METAS-ENV-GROUP', '');

/** @deprecated */
export function getToken() {
  console.warn('getToken方法弃用，有风险，请使用：userStore.getToken');
  return getAuthCache<string>(TOKEN_KEY);
}

export function getAuthCache<T>(key: BasicKeys) {
  const fn = isLocal ? Persistent.getLocal : Persistent.getSession;
  return fn(key) as T;
}

export function setAuthCache(key: BasicKeys, value) {
  const fn = isLocal ? Persistent.setLocal : Persistent.setSession;
  return fn(key, value, true);
}

export function clearAuthCache(immediate = true) {
  const fn = isLocal ? Persistent.clearLocal : Persistent.clearSession;
  return fn(immediate);
}
